// extracted by mini-css-extract-plugin
module.exports = {"countdownHolder":"EventCountdown_countdownHolder__2AGH2","countdownLineHolder":"EventCountdown_countdownLineHolder__3m-Hs"};